import React from 'react';

export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Datenschutzerklärung</h1>
        
        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
          <p className="text-sm text-gray-500">Stand: Januar 2026</p>
          
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Verantwortlicher</h2>
            <p>
              Wisecall<br />
              E-Mail: hello@wisecall.de
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Erhobene Daten</h2>
            <p>Wir erheben und verarbeiten folgende Daten:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Kontodaten:</strong> E-Mail-Adresse, Name, Passwort (verschlüsselt)</li>
              <li><strong>Nutzungsdaten:</strong> Anrufprotokolle, Transkripte, erstellte Agenten</li>
              <li><strong>Google Kalender-Daten:</strong> Bei Verbindung werden Kalender-Events (nur Lesezugriff) abgerufen, um Termin-Erinnerungen zu ermöglichen</li>
              <li><strong>Zahlungsdaten:</strong> Werden über Stripe verarbeitet, wir speichern keine Kreditkartendaten</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. Zweck der Datenverarbeitung</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Bereitstellung unserer KI-Telefonassistenten-Dienste</li>
              <li>Automatische Termin-Erinnerungen basierend auf Ihrem Kalender</li>
              <li>Abrechnung und Verwaltung Ihres Kontos</li>
              <li>Verbesserung unserer Dienste</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Google Kalender Integration</h2>
            <p>
              Wenn Sie Ihren Google Kalender verbinden, erhält Wisecall <strong>nur Lesezugriff</strong> auf Ihre Kalender-Events. 
              Wir können keine Events erstellen, ändern oder löschen. Die Daten werden verwendet, um:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Bevorstehende Termine zu erkennen</li>
              <li>Automatische Erinnerungsanrufe zu planen</li>
            </ul>
            <p className="mt-4">
              Sie können die Google Kalender-Verbindung jederzeit in Ihren Einstellungen trennen. 
              Dabei werden alle gespeicherten Kalender-Tokens gelöscht.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Datenweitergabe</h2>
            <p>Wir geben Ihre Daten nur an folgende Dritte weiter:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>OpenAI:</strong> Für die KI-Sprachverarbeitung</li>
              <li><strong>Twilio:</strong> Für Telefonie-Dienste</li>
              <li><strong>Stripe:</strong> Für Zahlungsabwicklung</li>
              <li><strong>Google:</strong> Für Kalender-Integration (nur bei aktiver Verbindung)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">6. Ihre Rechte</h2>
            <p>Sie haben das Recht auf:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Auskunft über Ihre gespeicherten Daten</li>
              <li>Berichtigung unrichtiger Daten</li>
              <li>Löschung Ihrer Daten</li>
              <li>Einschränkung der Verarbeitung</li>
              <li>Datenübertragbarkeit</li>
              <li>Widerspruch gegen die Verarbeitung</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">7. Datensicherheit</h2>
            <p>
              Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten 
              gegen Manipulation, Verlust oder unberechtigten Zugriff zu schützen. Dazu gehören:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>SSL/TLS-Verschlüsselung</li>
              <li>Verschlüsselte Passwort-Speicherung (bcrypt)</li>
              <li>Regelmäßige Sicherheitsupdates</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">8. Kontakt</h2>
            <p>
              Bei Fragen zum Datenschutz erreichen Sie uns unter:<br />
              E-Mail: hello@wisecall.de
            </p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-gray-200">
          <a href="/" className="text-emerald-600 hover:text-emerald-700 font-medium">
            ← Zurück zur Startseite
          </a>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
